require("prismjs/themes/prism-tomorrow.css");
const { createElement } = require("react");

const { PageElementWrapper } = require("./src/layout/page-element-wrapper");

module.exports.wrapPageElement = ({ props, element }) =>
  createElement(PageElementWrapper, props, element);
